import { HttpInterceptorFn } from '@angular/common/http';

const AUTH_KEY = 'ims-auth';

interface StoredAuth {
  email?: string;
  pin?: string;
  token?: string;
}

function readAuth(): StoredAuth | null {
  const raw = sessionStorage.getItem(AUTH_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as StoredAuth;
  } catch {
    return null;
  }
}

/** Attaches JWT + email/pin query params expected by IMS.Gateway. */
export const apiCredentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = readAuth();
  if (!auth) {
    return next(req);
  }

  let headers = req.headers;
  if (auth.token) {
    headers = headers.set('Authorization', `Bearer ${auth.token}`);
  }

  const isApiCall = req.url.includes('/api/') || req.url.startsWith('/api');
  const isAuthCall = /\/api\/Auth\//i.test(req.url);

  if (!isApiCall || isAuthCall || !auth.email || !auth.pin) {
    return next(req.clone({ headers }));
  }

  let params = req.params;
  if (!params.has('email')) {
    params = params.set('email', auth.email);
  }
  if (!params.has('pin')) {
    params = params.set('pin', auth.pin);
  }

  return next(req.clone({ headers, params }));
};
